import { SkipNext, SkipPrevious } from '@material-ui/icons';
import React, { Fragment } from 'react';
import { FaBook, FaHourglassStart } from 'react-icons/fa';
import { MdFirstPage, MdSkipPrevious } from 'react-icons/md';
import { ArcaComponent } from '../../pages/ArcaComponent';
import { ArcaLink } from '../Fields/ArcaLink';

export class PeoplePanelButtons extends ArcaComponent {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    render() {
        let { moreItems, pageIndex} = this.props;
        let colourClass = 'primaryButtonIcon'
        let colourClass2 = 'secondaryButtonIcon'
        let isFirstItem = pageIndex === 0

        return (

            <Fragment>
                <div className='centerText'>
                    <ArcaLink
                        text="First"
                        icon={<SkipPrevious size={'16px'} className={isFirstItem ? colourClass2 : colourClass} />}
                        disabled={isFirstItem}
                        onClick={() => {
                            this.props.pageTop()
                        }} />

                    <ArcaLink
                        text="Previous"
                        icon={<SkipPrevious size={'16px'} className={isFirstItem ? colourClass2 : colourClass} />}
                        disabled={isFirstItem}
                        onClick={() => {
                            this.props.pageUp()
                        }} />

                    <ArcaLink
                        text="Next"
                        icon={<SkipNext size={'16px'} className={moreItems ? colourClass : colourClass2} />}
                        disabled={!moreItems}
                        onClick={() => {
                            this.props.pageDown()
                        }} />
                </div>

            </Fragment >
        );
    }
}